export default "__VITE_ASSET__BVsamH$B__"